'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render"];
import * as React from 'react';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { CompositeList } from "../../base-ui-copy/composite/list/CompositeList.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export const CalendarGridHeaderRow = /*#__PURE__*/React.forwardRef(function CalendarGridHeaderRow(componentProps, forwardedRef) {
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const props = {
    role: 'row'
  };
  const cellsRefs = React.useRef([]);
  const element = useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [props, elementProps]
  });
  return /*#__PURE__*/_jsx(CompositeList, {
    elementsRef: cellsRefs,
    children: element
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridHeaderRow.displayName = "CalendarGridHeaderRow";